module.exports = __webpack_public_path__ + "73af6c4413abdd08b63c89915c6e952d.pdf";